import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { db } from "../firebase/firebaseConfig";

const Donations = () => {
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);

    const options = {
        title: "August",
    };
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "Donations"));
                const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAllData(documents);

                let totalTithe = 0;
                let totalOfferings = 0;
                let totalHOC = 0;
                let totalKids = 0;
                let totalYouth = 0;
                let totalMedia = 0;
                let totalCrusades = 0;
                let totalDonations = 0;
                let totalPlanting = 0;
                
                for (const key in documents) {
                    if (documents[key].Support === "Tithes") {
                        totalTithe += documents[key].Amount;
                    } else if (documents[key].Support === "Offerings") {
                        totalOfferings += documents[key].Amount;
                    }  else if (documents[key].Support === "HOC (Charity)") {
                        totalHOC += documents[key].Amount;
                    }  else if (documents[key].Support === "Kids Church") {
                        totalKids += documents[key].Amount;
                    }  else if (documents[key].Support === "Youth") {
                        totalYouth += documents[key].Amount;
                    }  else if (documents[key].Support === "Media") {
                        totalMedia += documents[key].Amount;
                    }  else if (documents[key].Support === "Crusades") {
                        totalCrusades += documents[key].Amount;
                    }  else if (documents[key].Support === "Donations") {
                        totalDonations += documents[key].Amount;
                    }  else if (documents[key].Support === "Church Plantings") {
                        totalPlanting += documents[key].Amount;
                    } 
                }

                const newArray = [["Task", "Donations in August"],["Tithe", totalTithe],["Offerings", totalOfferings],["HOC (Charity)", totalHOC],["Kids Church", totalKids],["Youth", totalYouth],["Media", totalMedia],["Crusades", totalCrusades],["Donations", totalDonations],["Church Plantings", totalPlanting]];
                setData(newArray);
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };
    
        fetchData();
    }, []);

    return (
        <div id="content">
            <div className='row'>
                <h1>Donations</h1>
                <h2 className='ev-sub-title'>Revival Church Montana</h2>
            </div>
            <div className='row'>
                <Chart
                    chartType="PieChart"
                    data={data}
                    options={options}
                    width={"100%"}
                    height={"400px"}
                />
            </div>
            <div className='row'>
                <h4 className='ev-sub-title'>Recent Donations</h4>
                <table>
                    <thead>
                        <tr>
                            <th>Amount</th>
                            <th>Support</th>
                            <th>Campus</th>
                            <th>Member</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allData.map(item => {
                            return (
                            <tr>
                                <td>R {item.Amount}.00</td>
                                <td>{item.Support}</td>
                                <td>{item.Campus}</td>
                                <td>{item.MemberId}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Donations;